<template lang="pug">
	header.new-header-back-desktop
		nav#menu.menu-container
			.h-content
				.first-item-new-menu
					a.logo(href="/")
						sfc-logo-desktop
				.second-item-new-menu
					ul.menu
						li.item.main-option(v-for="menu of menuJson" :key="menu.id"  v-if="menu.title != 'Login' && menu.title != 'Search'" :class="{'hovering': menu.is_hovering}" @mouseover="showSubelement(menu)" @mouseleave="hideSubelement(menu)" @click="trackAction('Menu Navigation Click', {'title': `${menu.title}`})")
							a(:href="menu.url")
								| {{menu.title}}
							.sub-menu(v-if="menu.children.length > 0")
								.menu-wrap
									.item.menu-subtitle(v-for="submenu of menu.children" :key="submenu.id")
										.wrap-option
											span.menu-heading-new
												| {{submenu.title}}
											ul.sub-menu2(v-if="submenu.children")
												li.menu-option(v-for="child of submenu.children" v-if="child.show_logged_out" :key="child.id" :class="{'subscription-link': child.title == 'Subscribe'}")
													a(v-if="child.id == '23'" :href="child.url" @click="trackAction('Menu Navigation Click', {'title': `${child.title}`})")
														| {{child.title}} {{currentYear}}
													a(v-else :href="child.url" @click="trackAction('Menu Navigation Click', {'title': `${child.title}`})")
														| {{child.title}}

												no-ssr(v-for="child of submenu.children" v-if="$store.state.userIsLoggedIn && !child.show_logged_out" :key="child.id")
													li.menu-option.no-ssrr
														a(:href="child.url" @click="trackAction('Menu Navigation Click', {'title': `${child.title}`})")
															| {{child.title}}
					.overlay
				.third-item-new-menu
					ul.menu
						li.item.main-option.login-menu(v-for="menu of menuJson" :key="menu.id"  v-if="menu.title == 'Login'" :class="{'hovering': menu.is_hovering}" @mouseover="showSubelement(menu)" @mouseleave="hideSubelement(menu)")
							no-ssr
								div.no-ssrr(v-if="!$store.state.userIsLoggedIn")
									a(@click="openLogin")
										| Login
					sfc-simple-button.start-saving(v-if="this.showCtaPlacementVariant" text="Find a 529 plan" :white="true" :mediumSize="true" @click="openSavingsCenter();trackActionGetStarted('Savings Center Navigation', 'Header menu click')" :loading="loadingSavingsCenterUser")
					sfc-simple-button.start-saving(v-else text="Get started" :white="true" :mediumSize="true" @click="openSavingsCenter();trackActionGetStarted('Savings Center Navigation', 'Header menu click')" :loading="loadingSavingsCenterUser")
					a(href="/search" @click="trackAction('Menu Navigation Click', {'title': 'Search'})" class="search-link")
						search-icon-black
					no-ssr
						ul.menu(v-if="$store.state.userIsLoggedIn")
							li.item.main-option.login-menu(v-for="menu of menuJson" :key="menu.id"  v-if="menu.title == 'Login'" :class="{'hovering': menu.is_hovering}" @mouseover="showSubelement(menu)" @mouseleave="hideSubelement(menu)")
								div
									a(href="#" class="account-link" @click.prevent="")
										login-icon
									.sub-menu
										.menu-wrap
											.item.menu-subtitle.logged-in
												.wrap-option
													a.account-subtitle
														| Account
													ul.sub-menu2
														li.menu-option
															a(href="/manage_account/")
																| Manage account
														li.menu-option
															a(:href="logoutUrl")
																| Logout
					.overlay
</template>

<style lang="stylus">
	.menu-savings-center-spinner
		display: inline-block
</style>

<style lang="stylus" scoped>
	@import '~assets/css/redesign-v1/variables.styl'

	.new-header-back-desktop
		background-color: #FFF
		color: #141414
		position: relative
		top: 0
		width: 100%
		z-index: 1010
		-webkit-font-smoothing: antialiased
		-moz-osx-font-smoothing: grayscale

		display: flex
		@media(max-width: 1214px)
			display: none
		.menu-container
			max-width: 1348px
			width: 100%
			margin: 0 auto
			padding: 0 12px
			a
				color: #fff
			.h-content
				align-items: center
				width: 100%
				display: flex
				display: -webkit-flex
				flex-wrap: wrap
				-webkit-flex-wrap: wrap
				align-content: center
				height: 100px

				.first-item-new-menu
				.second-item-new-menu
				.third-item-new-menu
					display: flex
					align-items: center

				.first-item-new-menu
					svg
						max-width: 100%
						width: 141px
						height: auto
					a
						svg
							&:hover
								>>>path
									fill: #145EE5!important

				.second-item-new-menu
					flex-grow: 2
					justify-content: center

				.second-item-new-menu
				.third-item-new-menu
					height: 100%
					ul.menu
						margin: 0
						padding-left: 0px
						height: 100%
						overflow: hidden
						@media(min-width: 992px) and (max-width: 1100px)
							padding-left: 10px
						li.main-option
							display: inline-block
							list-style: none
							padding: 40px 13px 37px
							margin: 0
							line-height: normal
							height: 100%
							@media(min-width: 992px) and (max-width: 1100px)
								padding: 40px 6px 37px
							a
								text-decoration none !important
								color: sfc-new-black !important
								font-family: main-font
								font-size: new-font-size
								font-weight: body-font-weight-strong
								padding 0
								&:hover
									color: sfc-new-blue!important
								.search-icon
									margin-left: 8px
									width: 16px
									height: 16px
									@media(min-width: 992px) and (max-width: 1120px)
										display: none
								@media(max-width: 1177px)
									font-size: body-font-size-md
							.sub-menu
								background-color: #fff
								flex-wrap: wrap
								margin-top: 36px
								position: absolute
								padding: 0
								left: 0
								right: 0
								flex-direction: column !important
								justify-content: space-between !important
								z-index: 1000
								display: flex
								display: -webkit-flex
								visibility: hidden
								.menu-wrap
									width: 100%
									max-width: 1176px
									margin: 0 auto
									height: auto
									overflow: hidden
									display: flex
									flex-wrap: wrap
									flex: 1
									justify-content: space-between
									padding: 32px 24px 60px
									.menu-subtitle
										display: flex
										flex: 1
										flex-wrap: wrap
										justify-content: center
										.wrap-option
											.menu-heading-new
												font-size: 18px
												font-family: main-font!important
												font-weight: body-font-weight-strong
												line-height: normal
												color: sfc-new-black !important
												cursor: default
											a.menu-heading-new
												text-transform: none
												cursor: pointer
												&:hover
													color: sfc-new-blue !important
													text-decoration: underline !important
											ul.sub-menu2
												margin: 20px 0 0 0
												height: auto
												display: flex
												flex-flow: column
												width: 100%
												padding: 0
												li.menu-option
													list-style: none
													margin-top: 8px
													line-height: normal
													a
														font-size: new-font-size
														line-height: 1.6
														color: sfc-new-black !important
														text-transform: none
														font-weight: normal
														text-decoration: underline !important
														text-decoration-color: sfc-new-blue!important
														&:hover
															color: sfc-new-blue !important
															text-decoration: underline !important
													&:first-of-type
														margin-top: 0
											a.account-subtitle
												font-family: main-font
												font-size: new-font-size
												font-weight: body-font-weight-strong
												line-height: normal
												color: sfc-new-black!important
												text-transform: none
												outline: none
												cursor: default
												&:hover
													text-decoration: none!important
													color: sfc-new-black!important
													cursor: default

							&:hover
								.sub-menu
									visibility: visible
				.overlay
					position: fixed
					left: 0
					right:0
					bottom: 0
					width: 100%
					height: 100%
					background-color: rgba(20, 20, 20, 0.3)
					pointer-events: none
					top: 231px
					z-index: 101
					visibility: hidden
				ul
					&:hover 
						& + .overlay
							visibility: visible
							pointer-events: auto
				.third-item-new-menu
					ul.menu
						padding-left: 0 !important
						@media(min-width: 992px) and (max-width: 1200px)
							padding-left: 0 !important
						li.login-menu
							div
								.sub-menu
									.menu-wrap
										min-height: 170px
										.menu-subtitle
											flex: unset !important
											width: 100% !important
											justify-content: flex-end !important
											margin-right: 14%
											&.logged-in
												margin-right: 12%
								>>>a
									color: sfc-new-blue !important
									text-decoration: none !important
									font-size: new-font-size
									font-family: main-font
									font-weight: body-font-weight-strong
									padding: 0
									&:hover
										color: #145EE5B3 !important
									@media(max-width: 1177px)
										font-size: body-font-size-md
					a
						svg
							&:hover
								>>>path
									fill: sfc-new-blue
					a.search-link
						display: flex
					a.account-link
						display: flex
						svg
							>>>path
								transition: stroke 0.3 ease
						&:hover
							svg
							>>>path
									fill: none!important
									stroke: sfc-new-blue

					
						
					>>>.sfc-simple-button
						margin: 0 30px 0 17px
						height: 46px;
						border-radius: 10px
						border: 2px solid sfc-new-blue !important
						@media(max-width: 1177px)
							width: 140px
						@media(min-width: 992px) and (max-width: 1150px)
							margin-left: 10px
							min-width: 100px
						.content
							.button-text
								font-size: 18px!important
								font-weight: body-font-weight-medium
								text-transform: none!important
								color: sfc-new-blue
								line-height: 1.6
								padding: 0 54px
								@media(max-width: 1177px)
									font-size: body-font-size-md !important
									padding: 0
						&:hover
							background-color: #edf2fc
</style>

<script>
	import SfcLogoDesktop from '@/common/components/icons/redesign-v1/sfc-logo-desktop-black'
	import SearchIconBlack from '@/common/components/icons/redesign-v1/search-icon-black'
	import LoginIcon from '@/common/components/icons/redesign-v1/login-icon'
	import SearchIcon from '@/common/components/icons/redesign-v1/search-icon'
	import SfcSimpleButton from '@/common/components/redesign-v1/sfc-simple-button'
	import SfcTrackingService from "@/lib/sfc-tracking-service"
	import Spinner from 'vue-simple-spinner/src/components/Spinner.vue'
	import StateOfResidenceQuestion from '@/common/components/savings-center/v3/onboarding/redesign-v1/state-of-residence.vue'
	import MenuJSON from '@/menu-footer.json'
	import { getNewJerseyExperimentVariant } from '@/lib/nj-experiment-helpers'

	export default {

	components:{
		SfcLogoDesktop,
		SearchIconBlack,
		LoginIcon,
		SearchIcon,
		SfcSimpleButton,
		Spinner,
		StateOfResidenceQuestion,
		MenuJSON
	},

	data() {
		return {
			currentYear: '',
			loadingSavingsCenterUser: false,
			savingsCenterFlow: false,
			logoutUrl: '/logout/',
			menuTimeout: undefined,
			menuJson: MenuJSON['menu'],
			showCtaPlacementVariant: false
		}
	},

	async mounted() {
		this.logoutUrl = '/logout/?return_url=${window.location.href}'

		this.currentYear = new Date().getFullYear()

		if(this.isIE()){
			let submenus = document.querySelectorAll('.second-item-new-menu .menu-wrap')
			submenus[0].style.minHeight = "400px"
			submenus[1].style.minHeight = "300px"
			submenus[2].style.minHeight = "480px"
			submenus[3].style.minHeight = "350px"
		}
		
		// CTA New Jersey experiment
		const variant = await getNewJerseyExperimentVariant(this.$cookies, this.$store)
		this.showCtaPlacementVariant = variant === 'B'
		//console.log("VARIANT menu", variant)
	},

	methods: {
		async openSavingsCenter(){
			let nextPageUrl = false

			nextPageUrl = await this.nextStep()

			if(nextPageUrl){
				window.location.href = nextPageUrl
			}else{
				setTimeout(()=>{
					this.$sfcModal.open("sfc-onboarding-modal-v3-2", {savingsCenterFlow: true})
				},0)
			}
		},

		async nextStep(){
			const tokenSavingsCenterInfo = this.$cookies.get("savings-center-info")

			if (tokenSavingsCenterInfo){
				if (this.$store.state.collegeSavingsUserOnboarding  && this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]){
					return "/savings-center/learn/how-much-will-college-cost"
					//return "/savings-center/" + this.$store.state.collegeSavingsUserOnboarding["next_step_v3"]
				}
			}
			else{
				return false
			}

		},

		trackAction(eventDescription, additionalInformation = false){
			SfcTrackingService.trackAction(eventDescription, "Navigation", "2", additionalInformation)
		},
		trackActionGetStarted(eventDescription, eventAction, additionalInformation = false){
			SfcTrackingService.trackAction(eventDescription, eventAction, "", additionalInformation)
		},

		showSubelement(menu){
			clearTimeout(this.menuTimeout)
			this.menuTimeout = setTimeout(() => {
				for(let m of this.menuJson){
					m.is_hovering = false
				}
				menu.is_hovering = true
			}, 400)
	 	},

	 	hideSubelement(menu){
	 		clearTimeout(this.menuTimeout)
			setTimeout(() => {
				menu.is_hovering = false
			}, 200)
	 	},

		openLogin(){
			window.location.href = '/login'
		},

		obModalShow(){
			this.savingsCenterFlow = false
		},

		runMethod(func){
			this[func]()
		},

		isIE(){
			let ua = window.navigator.userAgent
			let msie = ua.indexOf('MSIE ')
			if (msie > 0) {
				return true
			}

			let trident = ua.indexOf('Trident/')
			if (trident > 0) {
				return true
			}

			let edge = ua.indexOf('Edge/')
			if (edge > 0) {
				return false
			}

			// other browser
			return false
		}
	}
}
</script>
